import { render, staticRenderFns } from "./dimensionList.vue?vue&type=template&id=40c56d3a&scoped=true&"
import script from "./dimensionList.vue?vue&type=script&lang=js&"
export * from "./dimensionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c56d3a",
  null
  
)

export default component.exports